import React, { useState } from "react";
import {
  Box,
  Card,
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  styled,
} from "@mui/material";
import { chnagePassword } from "../../services/api";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

const Visible = styled('p')({
    margin: 0,
    fontSize: 14
})

const EditPass = () => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleToggleShow = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
      alert("Please fill in all fields.");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      alert("New passwords do not match.");
      return;
    }

    alert("Password changed successfully!");
  };

  const handleSubmitPassword = async () => {
    let resp = await chnagePassword({
        newPassword: formData?.newPassword,
        oldPassword: formData?.currentPassword
    })

    if(resp?.status === 200) {
        alert("Password changed")
    }

  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        p: 2,
      }}
    >
      <Card
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 400,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <Typography variant="h5" fontWeight="bold" textAlign="center" gutterBottom>
          Change Password
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            type={showPassword.current ? "text" : "password"}
            label="Current Password"
            name="currentPassword"
            value={formData.currentPassword}
            onChange={handleChange}
            margin="normal"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => handleToggleShow("current")}>
                    {showPassword.current ? <Visible>Show</Visible> : <Visible>Hide</Visible>}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            type={showPassword.new ? "text" : "password"}
            label="New Password"
            name="newPassword"
            value={formData.newPassword}
            onChange={handleChange}
            margin="normal"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => handleToggleShow("new")}>
                    {showPassword.new ? <Visible>Show</Visible> : <Visible>Hide</Visible>}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            type={showPassword.confirm ? "text" : "password"}
            label="Confirm New Password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            margin="normal"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => handleToggleShow("confirm")}>
                    {showPassword.confirm ? <Visible>Show</Visible> : <Visible>Hide</Visible>}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            sx={{ mt: 2, py: 1.2, borderRadius: 2 }}
            onClick={() => handleSubmitPassword()}
          >
            Update Password
          </Button>
        </form>
      </Card>
    </Box>
  );
};

export default EditPass;
